// Payment API functions

const API_BASE = process.env.REACT_APP_API_URL;

export const getPaymentPlans = async () => {
  const response = await fetch(`${API_BASE}/api/payments/plans`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("userAccessToken")}`,
    },
  });
  return response.json();
};

export const createPaymentOrder = async (planType) => {
  const response = await fetch(`${API_BASE}/api/payments/create-order`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("userAccessToken")}`,
    },
    body: JSON.stringify({ planType }),
  });
  return response.json();
};

export const verifyPayment = async (paymentData) => {
  const response = await fetch(`${API_BASE}/api/payments/verify`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("userAccessToken")}`,
    },
    body: JSON.stringify(paymentData),
  });
  return response.json();
};

export const checkSubscription = async () => {
  const response = await fetch(`${API_BASE}/api/payments/subscription/check`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("userAccessToken")}`,
    },
  });
  return response.json();
};

export const createInstanceOrder = async (planType, instanceName) => {
  const response = await fetch(
    `${API_BASE}/api/payments/create-instance-order`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("userAccessToken")}`,
      },
      body: JSON.stringify({ planType, instanceName }),
    }
  );
  return response.json();
};

export const verifyPaymentAndCreateInstance = async (paymentData) => {
  const response = await fetch(
    `${API_BASE}/api/payments/verify-and-create-instance`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("userAccessToken")}`,
      },
      body: JSON.stringify(paymentData),
    }
  );
  return response.json();
};

// Create Renewal Order (for existing instance)
export const createRenewalOrder = async (planType, instanceId) => {
  const response = await fetch(
    `${API_BASE}/api/payments/create-renewal-order`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("userAccessToken")}`,
      },
      body: JSON.stringify({ planType, instanceId }),
    }
  );

  return response.json();
};

// Verify Renewal Payment and Extend Subscription
export const verifyRenewalPayment = async (paymentData) => {
  const response = await fetch(
    `${API_BASE}/api/payments/verify-renewal-payment`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("userAccessToken")}`,
      },
      body: JSON.stringify(paymentData),
    }
  );

  return response.json();
};

export const getUserInstances = async () => {
  const response = await fetch(`${API_BASE}/api/payments/instances`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("userAccessToken")}`,
    },
  });
  return response.json();
};

export const getPaymentHistory = async () => {
  const response = await fetch(`${API_BASE}/api/payments/history`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("userAccessToken")}`,
    },
  });
  return response.json();
};

export const checkInstanceSubscription = async (instanceId) => {
  const response = await fetch(
    `${API_BASE}/api/payments/instance/${instanceId}/subscription`,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("userAccessToken")}`,
      },
    }
  );
  return response.json();
};
